import {
  enUS,
  fr,
  de,
  ar,
  cs,
  da,
  el,
  es,
  hr,
  it,
  ja,
  nl,
  pl,
  pt,
  ro,
  ru,
  sk,
  sv,
  tr,
  zhCN as zh,
  Locale,
} from 'date-fns/locale'

const localesMap: { [key: string]: Locale } = {
  ar,
  cs,
  da,
  de,
  el,
  es,
  fr,
  hr,
  it,
  ja,
  nl,
  pl,
  pt,
  ro,
  ru,
  sk,
  sv,
  tr,
  zh,
}

export const getDateFnsLocale = (lang: string) => localesMap[lang] || enUS
